import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TASKS = [
    { id: 1, text: "Mise à jour WordPress 🔴", x: 10, y: 20 },
    { id: 2, text: "Sauvegarde Base de Données 💾", x: 70, y: 15 },
    { id: 3, text: "Renouvellement SSL 🔒", x: 20, y: 60 },
    { id: 4, text: "Correction Bug CSS 🐛", x: 60, y: 70 },
    { id: 5, text: "Optimisation PHP ⚙️", x: 40, y: 40 },
    { id: 6, text: "Configuration DNS 🌐", x: 80, y: 30 },
    { id: 7, text: "Modération Commentaires 💬", x: 15, y: 80 },
];

export default function CommercialZenPage() {
    const navigate = useNavigate();
    const [zenMode, setZenMode] = useState(false);

    return (
        <div style={{ height: '100vh', width: '100vw', background: zenMode ? '#ecfdf5' : '#f1f5f9', transition: 'background 2s ease', position: 'relative', overflow: 'hidden', fontFamily: 'Inter, sans-serif' }}>

            {/* Background Image/Gradient */}
            {zenMode && (
                <div style={{ position: 'absolute', inset: 0, opacity: 0, animation: 'fadeIn 3s forwards', background: 'radial-gradient(circle at center, #d1fae5 0%, #ecfdf5 70%)' }}>
                    {/* Can add a lotus svg or image here */}
                    <div style={{ position: 'absolute', bottom: -50, right: -50, fontSize: '30rem', opacity: 0.1, color: '#10b981' }}>🧘</div>
                </div>
            )}

            {/* STRESS TASKS */}
            {!zenMode && TASKS.map((task, idx) => (
                <div
                    key={task.id}
                    className="float-stress"
                    style={{
                        position: 'absolute', left: `${task.x}%`, top: `${task.y}%`,
                        background: 'white', padding: '15px 25px', borderRadius: 8, boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
                        color: '#ef4444', fontWeight: 600, animationDelay: `${idx * 0.5}s`
                    }}
                >
                    {task.text}
                </div>
            ))}

            {/* CONTENT CENTER */}
            <div style={{ position: 'relative', zIndex: 10, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

                <h1 style={{ fontSize: '3.5rem', fontWeight: 900, marginBottom: 20, color: zenMode ? '#047857' : '#334155', transition: 'color 1s' }}>
                    {zenMode ? 'ZEN MODE' : 'VOTRE QUOTIDIEN ?'}
                </h1>

                <p style={{ fontSize: '1.5rem', maxWidth: 600, textAlign: 'center', marginBottom: 50, color: zenMode ? '#065f46' : '#64748b', lineHeight: 1.5 }}>
                    {zenMode ? "On s'occupe de tout. Vous vous occupez de votre business." : "Mises à jour, bugs, sécurité, sauvegardes... C'est du temps perdu."}
                </p>

                {!zenMode ? (
                    <button
                        onClick={() => setZenMode(true)}
                        style={{
                            padding: '25px 50px', borderRadius: 50, border: 'none', background: '#334155', color: 'white',
                            fontSize: '1.5rem', fontWeight: 700, cursor: 'pointer', boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
                        }}
                    >
                        ACTIVER LA DÉLÉGATION 🧘
                    </button>
                ) : (
                    <div className="animate-fade-up" style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '4rem', marginBottom: 20 }}>🌸</div>
                        <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#059669', marginBottom: 10 }}>Maintenance Intégrale Activée</div>
                        <div style={{ opacity: 0.7, color: '#047857' }}>Votre esprit est libre.</div>
                        <button onClick={() => navigate('/commercial/sign')} style={{ marginTop: 40, padding: '15px 40px', background: '#059669', color: 'white', border: 'none', borderRadius: 50, fontSize: '1.2rem', fontWeight: 700, cursor: 'pointer' }}>
                            SIGNER LE CONTRAT DE PAIX ✒️
                        </button>
                    </div>
                )}
            </div>

            <button onClick={() => navigate('/commercial/launchpad')} style={{ position: 'absolute', top: 30, right: 30, background: 'transparent', border: 'none', color: zenMode ? '#065f46' : '#64748b', cursor: 'pointer' }}>Quitter</button>

            <style>{`
                @keyframes fadeIn { to { opacity: 1; } }
                .float-stress { animation: float 3s ease-in-out infinite; }
                @keyframes float { 0% { transform: translateY(0); } 50% { transform: translateY(-10px); } 100% { transform: translateY(0); } }
                .animate-fade-up { animation: fadeUp 1s ease-out; }
                @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </div>
    );
}
